import { IMeetingPlanningState } from "./MeetingPlanningReducer"

export const selectDeliveryForm = (meetingPlanning: IMeetingPlanningState) => meetingPlanning

export const selectMeetingPlanning = (deliveryId: string | undefined, meetingPlanningState: IMeetingPlanningState) => {
    if (!deliveryId || !meetingPlanningState.meetingPlaningDeliveries.find(d => d.id === deliveryId)) { return null }

    return meetingPlanningState
}
